// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_dialog_paper__64P\\+e {
  max-width: 650px !important;
  border-radius: 8px !important;
  overflow: hidden !important;
}

.styles_dialog_title__bcMjc {
  background: linear-gradient(135deg, #d32f2f 0%, #c62828 100%);
  color: white !important;
  padding: 18px 25px !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  border-radius: 8px 8px 0 0 !important;
}

.styles_close_button__fli8Y {
  color: white !important;
  padding: 0 !important;
  width: 32px !important;
  height: 32px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 50% !important;
  transition: background 0.3s !important;
}

.styles_close_button__fli8Y:hover {
  background: rgba(255, 255, 255, 0.2) !important;
}

.styles_dialog_content__ntrdG {
  padding: 25px !important;
}

.styles_dialog_content__ntrdG .MuiDialogContent-root {
  padding: 25px !important;
}

.styles_alert_info__-Glku {
  background-color: #e3f2fd !important;
  border-left: 4px solid #1976d2 !important;
  padding: 12px !important;
  border-radius: 5px !important;
  margin-bottom: 20px !important;
  font-size: 12px !important;
  color: #0d47a1 !important;
}

.styles_saldo_disponivel__GorHH {
  background-color: #e8f5e9;
  padding: 12px;
  border-radius: 5px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.styles_saldo_disponivel_label__BdDLY {
  font-weight: 600 !important;
  color: #2e7d32 !important;
  font-size: 13px !important;
}

.styles_saldo_disponivel_value__lpdb4 {
  font-size: 18px !important;
  font-weight: 700 !important;
  color: #2e7d32 !important;
}

.styles_form_group__dxDkU {
  margin-bottom: 20px;
}

.styles_form_label__IoqmE {
  display: block;
  font-weight: 600;
  color: #0d2847;
  margin-bottom: 6px;
  font-size: 13px;
}

.styles_required__Vi99m {
  color: #d32f2f;
}

.styles_form_input__yeigi {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 14px;
  font-family: inherit;
  transition: border-color 0.3s;
}

.styles_form_input__yeigi:focus {
  outline: none;
  border-color: #1e4a7a;
  box-shadow: 0 0 0 3px rgba(30, 74, 122, 0.1);
}

.styles_form_select__7OXXP {
  width: 100%;
}

.styles_form_input__yeigi::placeholder {
  color: #999;
}

.styles_form_help__Q3ZKF {
  font-size: 11px;
  color: #666;
  margin-top: 4px;
}

.styles_alert_warning__HKbgG {
  background-color: #fff3e0 !important;
  border-left: 4px solid #f57c00 !important;
  padding: 12px !important;
  border-radius: 5px !important;
  margin-bottom: 20px !important;
  font-size: 12px !important;
  color: #e65100 !important;
}

.styles_dialog_actions__n4Lmf {
  padding: 15px 25px !important;
  border-top: 1px solid #e0e0e0;
  justify-content: flex-end;
  gap: 15px;
}

.styles_btn_cancelar__xha2q {
  background-color: #6c757d !important;
  color: white !important;
  border: none !important;
  padding: 10px 24px !important;
  border-radius: 5px !important;
  cursor: pointer !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  transition: background 0.3s !important;
}

.styles_btn_cancelar__xha2q:hover {
  background-color: #5a6268 !important;
}

.styles_btn_confirmar__r80v8 {
  background-color: #d32f2f !important;
  color: white !important;
  border: none !important;
  padding: 10px 24px !important;
  border-radius: 5px !important;
  cursor: pointer !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: background 0.3s !important;
  box-shadow: 0 2px 8px rgba(211, 47, 47, 0.3) !important;
}

.styles_btn_confirmar__r80v8:hover {
  background-color: #c62828 !important;
}

.styles_btn_confirmar__r80v8:disabled {
  background-color: #ccc !important;
  color: #666 !important;
  cursor: not-allowed !important;
  box-shadow: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ContaCorrente/ContaCorrenteDetalhes/ModalLancarDebito/styles.module.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,uBAAuB;EACvB,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,sCAAsC;EACtC,uDAAuD;AACzD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;AAC7B","sourcesContent":[".dialog_paper {\n  max-width: 650px !important;\n  border-radius: 8px !important;\n  overflow: hidden !important;\n}\n\n.dialog_title {\n  background: linear-gradient(135deg, #d32f2f 0%, #c62828 100%);\n  color: white !important;\n  padding: 18px 25px !important;\n  margin: 0 !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  border-radius: 8px 8px 0 0 !important;\n}\n\n.close_button {\n  color: white !important;\n  padding: 0 !important;\n  width: 32px !important;\n  height: 32px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  border-radius: 50% !important;\n  transition: background 0.3s !important;\n}\n\n.close_button:hover {\n  background: rgba(255, 255, 255, 0.2) !important;\n}\n\n.dialog_content {\n  padding: 25px !important;\n}\n\n.dialog_content :global(.MuiDialogContent-root) {\n  padding: 25px !important;\n}\n\n.alert_info {\n  background-color: #e3f2fd !important;\n  border-left: 4px solid #1976d2 !important;\n  padding: 12px !important;\n  border-radius: 5px !important;\n  margin-bottom: 20px !important;\n  font-size: 12px !important;\n  color: #0d47a1 !important;\n}\n\n.saldo_disponivel {\n  background-color: #e8f5e9;\n  padding: 12px;\n  border-radius: 5px;\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.saldo_disponivel_label {\n  font-weight: 600 !important;\n  color: #2e7d32 !important;\n  font-size: 13px !important;\n}\n\n.saldo_disponivel_value {\n  font-size: 18px !important;\n  font-weight: 700 !important;\n  color: #2e7d32 !important;\n}\n\n.form_group {\n  margin-bottom: 20px;\n}\n\n.form_label {\n  display: block;\n  font-weight: 600;\n  color: #0d2847;\n  margin-bottom: 6px;\n  font-size: 13px;\n}\n\n.required {\n  color: #d32f2f;\n}\n\n.form_input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  font-size: 14px;\n  font-family: inherit;\n  transition: border-color 0.3s;\n}\n\n.form_input:focus {\n  outline: none;\n  border-color: #1e4a7a;\n  box-shadow: 0 0 0 3px rgba(30, 74, 122, 0.1);\n}\n\n.form_select {\n  width: 100%;\n}\n\n.form_input::placeholder {\n  color: #999;\n}\n\n.form_help {\n  font-size: 11px;\n  color: #666;\n  margin-top: 4px;\n}\n\n.alert_warning {\n  background-color: #fff3e0 !important;\n  border-left: 4px solid #f57c00 !important;\n  padding: 12px !important;\n  border-radius: 5px !important;\n  margin-bottom: 20px !important;\n  font-size: 12px !important;\n  color: #e65100 !important;\n}\n\n.dialog_actions {\n  padding: 15px 25px !important;\n  border-top: 1px solid #e0e0e0;\n  justify-content: flex-end;\n  gap: 15px;\n}\n\n.btn_cancelar {\n  background-color: #6c757d !important;\n  color: white !important;\n  border: none !important;\n  padding: 10px 24px !important;\n  border-radius: 5px !important;\n  cursor: pointer !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  text-transform: none !important;\n  transition: background 0.3s !important;\n}\n\n.btn_cancelar:hover {\n  background-color: #5a6268 !important;\n}\n\n.btn_confirmar {\n  background-color: #d32f2f !important;\n  color: white !important;\n  border: none !important;\n  padding: 10px 24px !important;\n  border-radius: 5px !important;\n  cursor: pointer !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  text-transform: none !important;\n  transition: background 0.3s !important;\n  box-shadow: 0 2px 8px rgba(211, 47, 47, 0.3) !important;\n}\n\n.btn_confirmar:hover {\n  background-color: #c62828 !important;\n}\n\n.btn_confirmar:disabled {\n  background-color: #ccc !important;\n  color: #666 !important;\n  cursor: not-allowed !important;\n  box-shadow: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog_paper": `styles_dialog_paper__64P+e`,
	"dialog_title": `styles_dialog_title__bcMjc`,
	"close_button": `styles_close_button__fli8Y`,
	"dialog_content": `styles_dialog_content__ntrdG`,
	"alert_info": `styles_alert_info__-Glku`,
	"saldo_disponivel": `styles_saldo_disponivel__GorHH`,
	"saldo_disponivel_label": `styles_saldo_disponivel_label__BdDLY`,
	"saldo_disponivel_value": `styles_saldo_disponivel_value__lpdb4`,
	"form_group": `styles_form_group__dxDkU`,
	"form_label": `styles_form_label__IoqmE`,
	"required": `styles_required__Vi99m`,
	"form_input": `styles_form_input__yeigi`,
	"form_select": `styles_form_select__7OXXP`,
	"form_help": `styles_form_help__Q3ZKF`,
	"alert_warning": `styles_alert_warning__HKbgG`,
	"dialog_actions": `styles_dialog_actions__n4Lmf`,
	"btn_cancelar": `styles_btn_cancelar__xha2q`,
	"btn_confirmar": `styles_btn_confirmar__r80v8`
};
export default ___CSS_LOADER_EXPORT___;
